var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-header',[_c('Header')],1),_c('el-container',[_c('el-aside',{staticStyle:{"width":"200px"}},[_c('Aside',{staticStyle:{"height":"100%"},attrs:{"MenuListData":_vm.MenuList}})],1),_c('el-main',[_c('router-View')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }